import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { injectBetData } from "@fresh8/ad-data-composition/src/betData";
import { computed, ComputedRef } from "vue";
import {
  BackgroundImageSetMap,
  BackgroundImageSet,
  UserAsset
} from "@fresh8/types/src";

function useBackgroundImage(
  sizeId: ComputedRef<string>,
  type: string,
  imageSet?: ComputedRef<BackgroundImageSetMap>
): ComputedRef<{
  backgroundImage: string;
  backgroundImageSetName: string;
}> {
  const brand = injectBrand();

  const uniqueSports = computed(() => {
    const betData = injectBetData();
    const sports = new Set<string>();
    if (betData?.events?.value) {
      Object.keys(betData.events.value).forEach(key => {
        sports.add(betData.events.value[key].sport);
      });
    }
    return sports;
  });

  const imageSetType = computed(() => {
    if (imageSet) return imageSet.value;
    return type === "preroll"
      ? brand?.prerollImageSets.value
      : brand?.backgroundImageSets.value;
  });

  function getMatchingSizeAsset(assets: UserAsset[]): string {
    return (
      assets?.find(asset => asset.adSlotSize === sizeId.value)?.binary || ""
    );
  }

  const backgroundImageData = computed(() => {
    if (
      imageSetType.value?.preview &&
      typeof imageSetType.value.preview === "object"
    ) {
      return {
        backgroundImage: getMatchingSizeAsset(
          imageSetType.value.preview.userAssets
        ),
        backgroundImageSetName: ""
      };
    }

    if (uniqueSports?.value.size === 1) {
      const sport: string = uniqueSports.value
        .values()
        .next()
        .value?.toLowerCase()
        .replace(" ", "-");

      if (
        sport &&
        imageSetType.value?.[sport] &&
        typeof imageSetType.value[sport] === "object"
      ) {
        return {
          backgroundImage: getMatchingSizeAsset(
            (imageSetType.value[sport] as BackgroundImageSet)?.userAssets
          ),
          backgroundImageSetName:
            (imageSetType.value[sport] as BackgroundImageSet)?.name || ""
        };
      }
    }

    return {
      backgroundImage:
        (imageSetType.value?.default &&
          typeof imageSetType.value?.default === "object" &&
          getMatchingSizeAsset(imageSetType.value.default.userAssets)) ||
        "",
      backgroundImageSetName:
        (imageSetType.value?.default &&
          typeof imageSetType.value?.default === "object" &&
          imageSetType.value.default.name) ||
        ""
    };
  });

  return backgroundImageData;
}

export default useBackgroundImage;
